import { useCallback, useState } from 'react';
import { IFormAnswer, IQuestionAnswer } from './types';

export const useAnswerManager = () => {
  const [answers, setAnswers] = useState<IFormAnswer[]>([]);

  const handleChangeAnswer = useCallback((answerId: number, answer: IQuestionAnswer) => {
    setAnswers((prev) => {
      const updatedAnswers = prev.some(({ id }) => id === answerId)
        ? prev.map((data) => (data.id === answerId ? { ...data, answer } : data))
        : [...prev, { id: answerId, answer }];

      return updatedAnswers;
    });
  }, []);

  return { answers, handleChangeAnswer };
};
